const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StudioPromptQueryURL: any = {
    GetStudioPrompts: Backofficebff + '/v1/studio-prompts',
    GetStudioPromptById: Backofficebff + '/v1/studio-prompts',
};

